import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Typography, Button, Modal, Box, CircularProgress } from '@mui/material'
import { bool, func } from 'prop-types'

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ButtonsContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
`

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  padding: '2rem',
}

function ModalCancelAppointment({ openModal, setOpenModal, cancelAppointment, cancelling }) {
  const { t } = useTranslation()

  return (
    <Modal open={openModal} onClose={() => setOpenModal(false)}>
      <Box sx={modalStyle}>
        <ModalContentWrapper>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t('confirmCancellation')}
          </Typography>
          <Typography id="modal-modal-description" variant="body1" component="span">
            {t('areYouSure')}
          </Typography>
          <ButtonsContainer>
            <Button variant="text" onClick={() => setOpenModal(false)}>
              {t('no')}
            </Button>
            <Button
              variant="contained"
              onClick={() => cancelAppointment()}
              style={{ marginLeft: '1rem' }}
            >
              {cancelling ? <CircularProgress color="secondary" size={20} /> : t('yes')}
            </Button>
          </ButtonsContainer>
        </ModalContentWrapper>
      </Box>
    </Modal>
  )
}

ModalCancelAppointment.propTypes = {
  openModal: bool,
  setOpenModal: func,
  cancelAppointment: func,
  cancelling: bool,
}

export default ModalCancelAppointment
